<template>
  <div>
    <validation-observer ref="categoryForm">
      <b-form @submit.prevent=""
        @reset.prevent="resetForm">
        <b-row>
          <b-col cols="12">
            <validation-provider #default="validationContext"
              name="Tên chuyên mục"
              vid="name"
              rules="required">
              <b-form-group label="Tên chuyên mục"
                label-for="v-name">
                <b-form-input id="v-name"
                  v-model="frmData.name"
                  autofocus
                  :state="getValidationState(validationContext)"
                  placeholder="Tên chuyên mục" />
                <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Chuyên mục cha')">
              <v-select v-model="frmData.parent_id"
                :options="dataParent"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Loại chuyên mục')">
              <v-select v-model="frmData.content_type"
                :options="dataContentType"
                :reduce="(val) => val.code"
                placeholder="--Chọn--" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Vị trí')">
              <b-form-input id="v-position"
                v-model="frmData.position"
                :placeholder="$t('Sắp xếp')" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox v-model="frmData.status"
                value="1"> {{ $t('Kích hoạt') }} </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="12 mb-1">
            <b-button type="submit"
              variant="primary"
              class="mr-1 mt-1"
              @click.prevent="validationForm">
              <feather-icon icon="SaveIcon" /> {{ $t('Save') }} </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, alphaNum, min, max,
} from '@validations'
import {
  BCard, BLink, BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import vSelect from 'vue-select'
import { showToast } from '@core/utils/utils';

export default {
  components: {
    BCol,
    BRow,
    BButton,
    BCard,
    BFormGroup,
    BForm,
    BFormInput,
    BFormCheckbox,
    BLink,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    dataEdit: {
      type: Object,
      default: null,
    },
    dataParent: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dataContentType: [
        { label: 'Bài viết', code: 'news' },
        { label: 'Chuyên trang', code: 'content' },
        { label: 'Loại hình xuất bản', code: 'page' },
      ],
    }
  },
  setup(props, context) {
    const blankData = {
      name: '',
      content_type: 'news',
      parent_id: '',
      style: 1,
      image: '',
      lang: 'vi',
      position: '',
      status: 0,
    }

    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit
    }
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      frmData,
      resetfrmData,
    }
  },

  methods: {
    onSubmit() {
      if (this.frmData.id) {
        store.dispatch('category/update', { data: this.frmData, id: this.frmData.id })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.resetfrmData()
              this.$emit('updateList');
            } else if (result.errors) {
              this.$refs.categoryForm.setErrors(result.errors);
            } else {
              showToast(result.message);
            }
          })
      } else {
        store.dispatch('category/create', this.frmData)
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else if (result.errors) {
              this.$refs.categoryForm.setErrors(result.errors);
            } else {
              showToast(result.message);
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.categoryForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
